class UserLimitsService {
    async getLimits () {
        return await axios
            .get('user-limits')
            .then((response) => {
                if (response?.name !== 'AxiosError') {
                    return response.data.data
                } else {
                    return []
                }
            })
    }
}

export function useUserLimitsService () { return new UserLimitsService()}
